import {
  GET_PERMISSIONS,
  GET_PERMISSIONS_FAIL,
  GET_PERMISSIONS_SUCCESS,
  ADD_NEW_PERMISSION,
  ADD_PERMISSION_SUCCESS,
  ADD_PERMISSION_FAIL,
  UPDATE_PERMISSION,
  UPDATE_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_FAIL,
  DELETE_PERMISSION,
  DELETE_PERMISSION_SUCCESS,
  DELETE_PERMISSION_FAIL,
  
} from "./actionTypes";

export const getPermissions = () => ({
  type: GET_PERMISSIONS,
})

export const getPermissionsSuccess = PERMISSIONS => ({
  type: GET_PERMISSIONS_SUCCESS,
  payload: PERMISSIONS,
})

export const getPermissionsFail = error => ({
  type: GET_PERMISSIONS_FAIL,
  payload: error,
})

export const addNewPermission = data => ({
  type: ADD_NEW_PERMISSION,
  payload: data,
})

export const addPermissionSuccess = PERMISSION => ({
  type: ADD_PERMISSION_SUCCESS,
  payload: PERMISSION,
})

export const addPermissionFail = error => ({
  type: ADD_PERMISSION_FAIL,
  payload: error,
})

export const updatePermission = PERMISSION => ({
  type: UPDATE_PERMISSION,
  payload: PERMISSION,
})

export const updatePermissionSuccess = PERMISSION => ({
  type: UPDATE_PERMISSION_SUCCESS,
  payload: PERMISSION,
})

export const updatePermissionFail = error => ({
  type: UPDATE_PERMISSION_FAIL,
  payload: error,
})

export const deletePermission = data => ({
  type: DELETE_PERMISSION,
  payload: data,
})

export const deletePermissionSuccess = data => ({
  type: DELETE_PERMISSION_SUCCESS,
  payload: data,
})

export const deletePermissionFail = error => ({
  type: DELETE_PERMISSION_FAIL,
  payload: error,
})

